import { render } from "./PageComponent.vue?vue&type=template&id=5e331836"
import script from "./PageComponent.vue?vue&type=script&lang=js"
export * from "./PageComponent.vue?vue&type=script&lang=js"

import "./PageComponent.vue?vue&type=style&index=0&id=5e331836&lang=css"

import exportComponent from "/var/www/staging.no-menu.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__